import React from "react";
import { Autocomplete, TextField } from "@mui/material";
import "./filter-options-tenant.scss";
import { TimezoneFilterProps } from "./tenant-filter-helper";

const TimezoneFilter: React.FC<TimezoneFilterProps> = ({
  value = [],
  onChange,
  timezones,
  isTimezoneEnabled = true,
  multiple = true,
  error
}) => {
  if (!isTimezoneEnabled) return null;

  const selectedTimezones = timezones.filter((timezone) =>
    value.includes(timezone.value)
  );

  return (
    <div className="tenant-filter-select-input-wrapper">
      <Autocomplete
        multiple={multiple}
        options={timezones}
        value={selectedTimezones}
        getOptionLabel={(option) => option.value}
        onChange={(_, newValue) => {
          const selected = Array.isArray(newValue) ? newValue : [newValue];
          onChange(
            selected
              .map((item) => item?.value)
              .filter((val): val is string => Boolean(val))
          );
        }}
        disableCloseOnSelect={multiple}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Timezone"
            size="small"
            error={!!error}
            helperText={error}
            fullWidth
          />
        )}
      />
    </div>
  );
};

export default TimezoneFilter;